import { render, staticRenderFns } from "./searchStaff.vue?vue&type=template&id=4187836c&scoped=true"
import script from "./searchStaff.vue?vue&type=script&lang=js"
export * from "./searchStaff.vue?vue&type=script&lang=js"
import style0 from "./searchStaff.vue?vue&type=style&index=0&id=4187836c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187836c",
  null
  
)

export default component.exports